import { createContext } from "react";

export const ChargeContext = createContext({});